import { useState } from "react";
import { FileDown, Loader2, Presentation } from "lucide-react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { saveBlob } from "@/lib/download";

const cls = "h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-surface transition-colors disabled:opacity-40";

export const PdfButton = ({ kajianId, tajuk, teks, label = "Muat turun PDF", testid }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { saveBlob(await api("post", `/hte/kajian/${kajianId}/bahan.pdf`, { tajuk, teks }, { responseType: "blob" }), `${tajuk}.pdf`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <button onClick={go} disabled={busy} className={cls} data-testid={testid}>{busy ? <Loader2 size={14} className="animate-spin" /> : <FileDown size={14} />} {label}</button>;
};

export const PptButton = ({ kajianId, tajuk }) => {
  const api = useApi();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { saveBlob(await api("get", `/hte/kajian/${kajianId}/slaid.pptx`, null, { responseType: "blob" }), `Slaid - ${tajuk}.pptx`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <button onClick={go} disabled={busy} className={cls} data-testid="material-ppt-button">{busy ? <Loader2 size={14} className="animate-spin" /> : <Presentation size={14} />} Muat turun PPT</button>;
};
